// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:14:03

export default {
  "id": "mushroom-fever-match-3",
  "slug": "mushroom-fever-match-3",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/cd0511c805e64eee88e6268af506d4c3-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/cd0511c805e64eee88e6268af506d4c3/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Mushroom Fever Match 3",
      "description": "Immerse yourself in the magical forest with Mushroom Fever - Match 3! Bright and cheerful mushrooms replace traditional crystals, adding a fresh twist to the classic match-3 genre. This game will bring you hours of thrilling fun and bursts of excitement!\n\nMatch groups of three or more mushrooms, complete engaging tasks, and unlock new levels! Each level brings unique puzzles and fresh challenges. The more matches you make, the more points and bonuses you’ll earn!",
      "instructions": "1. Collect Mushrooms: Your goal is to gather as many groups of three or more matching mushrooms as possible. Swap them around to create rows or columns of identical mushrooms.\n2. Complete Tasks: Each level has unique objectives, such as collecting a specific number of mushrooms or reaching a target score within a limited number of moves.\n3 .Use Bonuses and Boosters: The game features special power-ups to help you progress faster.",
      "genres": [
        "Match-3"
      ],
      "tags": [
        "color",
        "logic",
        "match3"
      ]
    },
    "zh-CN": {
      "title": "蘑菇发烧三消",
      "description": "沉浸在魔幻森林中，体验蘑菇热潮——匹配3游戏！明亮欢快的蘑菇取代了传统的晶体，为经典的匹配3游戏类型增添了新意。这款游戏将为您带来数小时的刺激乐趣和兴奋瞬间！\n\n匹配三组或更多蘑菇，完成引人入胜的任务，解锁新关卡！每个关卡都带来独特的谜题和新的挑战。您匹配的越多，获得的分数和奖励就越多！",
      "instructions": "1. 收集蘑菇：你的目标是尽可能多地收集三或更多相同蘑菇的组合。通过交换它们的位置来创建一排或一列相同蘑菇的行或列。\n2. 完成任务：每个关卡都有独特的目标，例如收集特定数量的蘑菇或在有限的步数内达到目标分数。\n3. 使用奖励和增强器：游戏包含特殊道具，帮助你更快地进步。",
      "genres": [
        "三消游戏"
      ],
      "tags": [
        "颜色",
        "逻辑",
        "三消"
      ]
    },
    "zh-TW": {
      "title": "蘑菇瘋瘋拼3",
      "description": "沉浸在蘑菇瘋狂——三消的魔法森林中！明亮的蘑菇取代了傳統的水晶，為經典的三消遊戲增添了新鮮感。這款遊戲將帶給你數小時的刺激樂趣和興奮衝擊！\n\n匹配三個或更多蘑菇，完成引人入勝的任務，並解鎖新關卡！每個關卡都帶來獨特的謎題和新的挑戰。你匹配的越多，獲得的分數和獎勵也越多！",
      "instructions": "1. 收集蘑菇：你的目標是收集盡可能多的三顆或以上相同蘑菇的組合。交換它們的位置，以創建一排或一列完全相同的蘑菇。\n2. 完成任務：每個關卡都有獨特的目標，例如收集特定數量的蘑菇或在一個限制的步數內達到目標分數。\n3. 使用獎勵和加強器：遊戲提供特殊的加強功能，幫助你更快進步。",
      "genres": [
        "對戰3"
      ],
      "tags": [
        "顏色",
        "邏輯",
        "三消匹配"
      ]
    },
    "zh-HK": {
      "title": "蘑菇熱三消遊戲",
      "description": "投入魔幻森林的奇遇，玩蘑菇瘋狂—三消！亮麗快活的蘑菇取代傳統的晶石，為經典三消遊戲帶來新鮮感！遊戲將帶來數小時的刺激快樂和驚喜！\n匹配三顆或以上蘑菇，完成挑戰任務，解鎖新關卡！每關都帶來獨特的謎題和新挑戰。你匹配得越多，獲得的分數和獎勵也越多！",
      "instructions": "1. 收集蘑菇：你的目標是盡可能地收集三顆或以上匹配的蘑菇組合。交換它們的位置以創建同一種蘑菇的行列。\n2. 完成任務：每個關卡都有獨特目標，例如收集特定數量的蘑菇或在有限的步數內達到目標分數。\n3. 使用獎勵和加強器：遊戲提供特殊強化功能，以幫助你更快進步。",
      "genres": [
        "配對3"
      ],
      "tags": [
        "顏色",
        "邏輯",
        "三消匹配"
      ]
    },
    "ja": {
      "title": "マッシュルームフィーバーマッチ3",
      "description": "マッシュルーム・フィーバー - マッチ3！で魔法の森に没頭してください。明るく元気なマッシュルームが伝統的なクリスタルに替わり、クラシックのマッチ3ジャンルに新たな風を吹かせます。このゲームは、数時間にわたるスリル満点の楽しみと興奮の波を提供します！\n\n3つ以上のマッシュルームをマッチさせ、魅力的なタスクを完了し、新しいレベルを解禁しましょう！各レベルはユニークなパズルと新たな挑戦を持ちます。マッチさせた数が増えるほど、ポイントやボーナスを獲得できます！",
      "instructions": "1. キノコを収集する：目標は、できるだけ多くの3個以上の一致するキノコのグループを集めることです。一致するキノコを行や列に並べ替えてください。\n2. タスクを完了する：各レベルには独自の目標があります。例えば、特定の数のキノコを収集したり、制限された手数内に特定の得点に達するなどです。\n3. ボーナスとブースターを使用する：ゲームには、進行を速めるための特別なパワーアップが含まれています。",
      "genres": [
        "マッチ3"
      ],
      "tags": [
        "色",
        "論理",
        "マッチ3"
      ]
    },
    "ko": {
      "title": "蘑菇热匹配3",
      "description": "마ushroom Fever - Match 3로 마법의 숲에 몰입해 보세요! 밝고 기운이 넘치는 버섯이 전통적인 크리스탈을 대체하여 클래식 매치 3 장르에 새로운 전환을 더합니다. 이 게임은 시간이 지나면서 즐거움과 기쁨을 쏟아낼 것입니다!\n\n세 개 이상의 버섯을 매칭하며 흥미로운 태스크를 완료하고 새로운 레벨을 해금하세요! 각 레벨은 독특한 퍼즐과 새로운 도전을 제공합니다. 더 많은 매칭을 하면 더 많은 포인트와 보너스를 얻을 수 있습니다!",
      "instructions": "1. 버섯 수집: 목표는 가능한 많은 그룹의 세 개 이상 일치하는 버섯을 모으는 것입니다. 동일한 버섯의 행이나 열을 만들기 위해 버섯을 바꿔서 배치하세요.\n2. 임무 완료: 각 레벨마다 독특한 목표가 있습니다. 예를 들어, 특정 수의 버섯을 모으거나 제한된 횟수 이내에 목표 점수에 도달하는 것입니다.\n3. 보너스와 보스터 사용: 게임에는 진행을 빠르게 도와주는 특별한 파워업이 포함되어 있습니다.",
      "genres": [
        "매치3"
      ],
      "tags": [
        "색",
        "논리",
        "매치3"
      ]
    },
    "fr": {
      "title": "Maladie des Champignons Match 3",
      "description": "Immergez-vous dans la forêt magique avec la Ferveur des Champignons - Correspondance 3! Des champignons lumineux et joyeux remplacent les cristaux traditionnels, apportant un renouveau au genre classique du match-3. Ce jeu vous offrira des heures de divertissement captivant et des éclats de joie!\n\nFaites correspondre des groupes de trois ou plus de champignons, accomplissez des tâches captivantes et débloquez de nouveaux niveaux ! Chaque niveau apporte des énigmes uniques et des défis nouveaux. Plus les matches que vous faîtes, plus vous gagnez de points et de bonus !",
      "instructions": "1. Ramasser des champignons : Votre objectif est de rassembler le plus grand nombre possible de groupes de trois ou plus de champignons correspondants. Échangez-les pour créer des rangées ou des colonnes de champignons identiques.\n2. Compléter les tâches : Chaque niveau a des objectifs uniques, tels que la collecte d'un certain nombre de champignons ou l'atteinte d'un score cible dans un nombre limité de mouvements.\n3. Utiliser les bonus et les boosters : Le jeu propose des power-ups spéciaux pour vous aider à progresser plus rapidement.",
      "genres": [
        "Match-3"
      ],
      "tags": [
        "couleur",
        "logique",
        "match3"
      ]
    }
  }
};
